// Helpers shared between CopilotPanel (encodes CONFIRM_TOOL wire payload) and
// MessageBubble (computes signatures to detect proposedAction widgets that
// the LLM re-emits after the user already confirmed the equivalent action).

const CONFIRM_TOOL_PREFIX = 'CONFIRM_TOOL '

export const encodeConfirmationPayload = (
  args: Record<string, unknown>,
): string => {
  try {
    const json = JSON.stringify(args)
    // UTF-8 safe btoa: percent-encode to ASCII bytes, then base64.
    // Mirrors the server's Buffer.from(base64, 'base64').toString('utf-8').
    const utf8 = encodeURIComponent(json).replace(
      /%([0-9A-F]{2})/g,
      (_, hex: string) => String.fromCharCode(parseInt(hex, 16)),
    )
    return window.btoa(utf8)
  } catch (error) {
    console.error('Failed to encode confirmation payload:', error)
    return ''
  }
}

export const buildActionSignature = (
  action: string,
  args: Record<string, unknown>,
): string => `${action}|${encodeConfirmationPayload(args)}`

// Parses a CONFIRM_TOOL user message back into the signature the LLM-side
// equivalent would produce via buildActionSignature, so duplicate widgets
// can be matched against signals the user already confirmed.
export const parseConfirmedSignature = (
  messageContent: string,
): string | null => {
  if (!messageContent.startsWith(CONFIRM_TOOL_PREFIX)) return null
  const parts = messageContent.split(' ')
  // CONFIRM_TOOL <toolName> <base64 args> [<hmacToken>] — the optional 4th
  // field (token) does not participate in the signature, which is keyed only
  // on action + args, so accept 3 or 4 fields.
  if (parts.length < 3) return null
  return `${parts[1]}|${parts[2]}`
}
